import React from 'react'

import './_badge.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'span'>,
  {
    label: string
    icon?: React.ReactNode
    type?:
      | 'base'
      | 'brand'
      | 'error'
      | 'success'
      | 'warning'
      | 'warning-alternative'
      | 'cyan'
      | 'pink'
      | 'purple'
      | 'gold'
    size?: 'default' | 's' | 'xs'
    appearance?: 'base' | 'alternative'
  }
>

const Badge = ({
  className,
  label,
  icon,
  type = 'base',
  size = 'default',
  appearance = 'base',
  ...props
}: Props) => (
  <span
    {...props}
    className={cn(
      'Badge',
      {[`type-${type}`]: !!type, [`size-${size}`]: true, [`appearance-${appearance}`]: true},
      className
    )}
  >
    {appearance === 'base' && icon}
    {label}
  </span>
)

export default Badge
